import React from "react"
import { Grid, Typography } from "@material-ui/core"
import { TextField } from "@/popups/components/TextField"
import PhoneInputComponent from "@/components/PhoneInput"
import useStyles from "@/popups/templates/AccountOwnerContactUpdate/styles"

export type AccountOwnerContactUpdateValue = {
	name: string
	phone: string
}

export type AccountOwnerContactUpdateFieldErrors = {
	name?: string
	phone?: string
}

export type AccountOwnerContactUpdateProps = {
	value: AccountOwnerContactUpdateValue
	onChange: (value: AccountOwnerContactUpdateValue) => void
	errors?: AccountOwnerContactUpdateFieldErrors
}

export const AccountOwnerContactUpdate: React.FC<AccountOwnerContactUpdateProps> = ({
	value,
	onChange,
	errors
}) => {
	const classes = useStyles()

	return (
		<Grid container direction="column" spacing={3}>
			<Grid item>
				<Typography className={classes.fieldLabel}>
					Nome
				</Typography>
				<TextField
					value={value.name}
					onChange={(name) => onChange({ ...value, name })}
					placeholder="Digite seu nome"
				/>
				{errors?.name && (
					<Typography className={classes.errorText}>
						{errors.name}
					</Typography>
				)}
			</Grid>

			<Grid item>
				<Typography className={classes.fieldLabel}>
					Telefone
				</Typography>
				<PhoneInputComponent
					value={value.phone}
					onChange={({ formattedPhone }) => onChange({ ...value, phone: formattedPhone })}
					validation={errors?.phone}
					country="br"
					preferredCountries={["br", "pt", "us"]}
					specialLabel=""
				/>
			</Grid>
		</Grid>
	)
}
